module.exports = __webpack_public_path__ + "img/delete.bb223413.svg";